import React, {PureComponent} from "react";
import Api from "../../utils/api_calls";
import Common from "../../utils/common";
import Playerlib from "../../libs/player";
import Analytics from "../../libs/analytics";
import AssetDetails from "../AssetDetails/AssetDetails";
import "./Player.scss";
import Products from "../Products/Products";
import * as actionTypes from "../../store/actions";
import store from "../../store/store";
import Dotdotdot from "react-dotdotdot";
import PlayerEndOverlay from "../PlayerEndOverlay/PlayerEndOverlay";
import { createBrowserHistory } from 'history'
import ConfigurationHelper from "../../configuration/ClientConfigurationHelper";
import theme from "../../../sass/variables.json";

const history = createBrowserHistory();

class Player extends PureComponent {
    constructor(props) {
        super(props);
        const hasProducts = (props.asset && props.asset.matched && props.asset.matched.length > 0) ? true : false;
        this.state = {
            hasProducts: hasProducts,
            products: props.products || [],
            asset: props.asset || null,
            player: null,
            ambassador: null,
            nextAsset: null,
            showEndOverlay: false
        };
        Common.createAssetStructureData(props.asset);
    }

    loadProducts = (asset) => {
        Api.products(Common.getProductsEndpoint(asset))
            .then(this.setProductsResponse)
            .then(hasProducts=> {
                if (!hasProducts && ConfigurationHelper.useRecommendedProducts() && !Common.isPhoto(asset)) {
                    Api.recommendedProducts(
                        Common.getRecommendedProductsEndpoint(asset),
                        ConfigurationHelper.getLatestVideosChannelId())
                        .then(response => {
                            this.setProductsResponse({...response, data : response.data.splice(0,4)})
                        });
                }
            });
    }
    setProductsResponse = (response) => {
        const that = this;
        const {asset} = this.state;
        const {data} = response;

        const products = data && data.matches ? data.matches : data;
        let newState = {};
        if (products && !products.length) {
            newState = {
                hasProducts: false,
                products: []
            };
        } else {
            for (let index = 0; index < products.length; index++) {
                let element = products[index].entity ?  {...products[index].entity, ...products[index].entity.data} : products[index];
                element.entityIdParent = asset.id;
                Analytics.productImpresion(element, asset.id);
                Common.createProductStructureData(element);
            }
            newState = {
                products: products.map(productItem => {
                    return !!productItem.entity ? {...productItem.entity, ...productItem.entity.data} : productItem;
                }),
                hasProducts: true
            };
            setTimeout(() => {
                that.state.player.resize();
            }, 100);
        }
        that.setState(newState);
        return newState.hasProducts;
    }
    storeSubscribe = () => {
        const {player} = this.state;
        const storeState = store.getState();
        if (storeState.event === actionTypes.UPDATE_ASSET) {
            this.setState({
                nextAsset: storeState.asset,
                showEndOverlay: true
            });
        }else if(storeState.event === actionTypes.UPDATE_PRODUCT_MODAL){
            if(storeState.product_modal.modalOpen){
                player.instance.pause();
            }else{
                player.instance.removeOverlay();
                player.instance.play();
            }
        }
    }
    playerStateChange = (e) => {
		const {asset} = this.state;
		e = e.toString();
        const validEvents = ['tvp:video:view', 'tvp:video:view:25p', 'tvp:video:view:100p'];
        if(validEvents.includes(e)){
            Analytics._GA_EVENTS('event',{
                'event_category' : 'videos',
                'event_label' : asset.title,
                'event_action': e
            });
        }




        if ('tvp:media:videoended' === e) {
            setTimeout(() => {
                store.dispatch({
                    type: actionTypes.PLAYER_EVENT,
                    player_event: e
                })
            }, 200);

        }
    }
    play = () => {
        const {nextAsset, player} = this.state;
        document.querySelector('.video-playing-title').innerHTML = nextAsset.title;
        history.push(Common.getVideoPageUrl(nextAsset));
        player.loadSelected(nextAsset);
        this.loadProducts(nextAsset);
        this.getAmbassador(nextAsset);
        this.setCurrentAsset(nextAsset.id);
        this.setState({
            asset: nextAsset,
            showEndOverlay: false
        });
    }
    replay = () => {
        const {asset, player} = this.state;
        player.loadSelected(asset);
        this.setCurrentAsset(asset.id);
        this.setState({
            showEndOverlay: false
        });
    }

    setCurrentAsset(assetId) {
        store.dispatch({
            type: actionTypes.CURRENT_VIDEO,
            CURRENT_VIDEO: assetId
        })
    }
    getAmbassador = (asset) => {
        const that = this;
        if(asset && asset.user_id && ConfigurationHelper.isAmbassadorProgramEnabled()){
            Api.ambassador(asset.user_id).then( response => {
                const ambassadorResponse = (response && response.data && response.data.user_id) ? response.data : null;
                store.dispatch({
                    type: actionTypes.UPDATE_BREADCRUMBS,
                    ambassador: ambassadorResponse,
                    asset: asset
                });
                that.setState({
                    ambassador: ambassadorResponse
                });
            });
        }else if(asset){
            setTimeout(()=>{
                store.dispatch({
                    type: actionTypes.UPDATE_BREADCRUMBS,
                    ambassador: null,
                    asset: asset
                });
            },0)
        }
    }

    initPlayer() {
        const options = {
            play_button_border_radius: '50%',
            play_button_border_width: '5px',
            play_button_border_color: theme.play_icon_color,
            play_button_border_style: 'solid',
            play_button_background_color: theme.play_icon_color,
            overlay_opacity: 1,
            poster: true,
            progress_color: theme.player_progressbar_color,
            api_base_url: ConfigurationHelper.getGlobalConfiguration().apiUrl,
            data: [this.state.asset],
            analytics: true,
            autoplay: false,
            autonext: true,
            loginId: ConfigurationHelper.getGlobalConfiguration().loginId,
            playerStateChange: this.playerStateChange
        };
        const globalConfig = {
            playerStateChange: this.playerStateChange
        }
        return new Playerlib('tvpageplayer', options, globalConfig);

    }

    componentDidMount() {
        const player = this.initPlayer();
        this.setState({player: player});

        const {asset} = this.props;
        const assetObjId = asset.id;

        if (asset.hasOwnProperty("id")) {
            this.getAmbassador(asset);
            this.loadProducts(asset);
        }
        store.subscribe(this.storeSubscribe)

    }

    render() {
        const {asset, nextAsset, showEndOverlay, products, hasProducts, ambassador} = this.state;
        const {enableDetails} = this.props;
        const userHashId = ambassador && ambassador.hashId ? ambassador.hashId : null;
        const publishedDate = Common.getDateFromUnix(asset.date_created);
        return (
            <div ref="tvpageplayer">
                <div className="tvp-player-products-container">
                    <div id="player-container" className="player-container container">
                        <div className="row">
                            <div className={"col-12"}>
                                <div className={"row"}>

                                    <div id="tvpageplayer-container"
                                         className={`col-sm-12 col-md-12 col-lg-${hasProducts?10:12}`}>
                                        <div id="tvpageplayer-wrapper" className="TVPagePlayer-wrapper">
                                            <div id="tvpageplayer" className="tvp-player">
                                            </div>
                                            {
                                                showEndOverlay &&
                                                <PlayerEndOverlay play={this.play} replay={this.replay} asset={asset}
                                                                  nextAsset={nextAsset}/>
                                            }
                                        </div>
                                    </div>

                                    {hasProducts && <Products asset={asset} userHashId={userHashId} products={products}/>}

                                </div>
                            </div>
                        </div>
                        <div className={"row"}>
                            <div id="video-playing-title-holder" className="clearfix col-12">


                                <h1 id="video-playing-title" className="video-playing-title">
                                    <Dotdotdot clamp={2}>
                                        {asset.title}
                                    </Dotdotdot>
                                </h1>


                            </div>
                        </div>
                        <div className={"row"}>
                            <div className={"col-12 time-date-container"}>
                                <div className={"tvp-published"}>
                                    <span>Published on </span>
                                    {publishedDate && <span>{publishedDate}</span>}
                                </div>
                                {(asset.asset && asset.asset.prettyDuration) && <div className={"tvp-duration"}>
                                    <span>Duration:</span>
                                     <span> {asset.asset.prettyDuration}</span>
                                </div>}

                            </div>
                        </div>
                        <div className="row">
                            {enableDetails && <AssetDetails asset={asset} ambassador={ambassador} enableAmbassador/>}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

Player.defaultProps = {
    enableDetails: true
};

export default Player;